import { DateFormats } from '@routable/shared';
import React from 'react';
import { getDate, getObjDate } from 'helpers/date';
import TableCellText from '../TableCellText';
import {} from './DateCell.types';
const DateCell = ({ className, value, dataKey, defaultValue = '--', format = DateFormats.SHORT_ALPHA_MONTH_FULL_YEAR, rowData, }) => (React.createElement(TableCellText, { className: className }, (value ? getDate(value, format) : getObjDate(rowData, dataKey, format)) || defaultValue));
export default DateCell;
